import React, { useState, useEffect, useRef } from 'react';
import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe, Play, Pause } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const VideoAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const videoRef = useRef(null);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleExpand = () => {
    if (onExpand && !isInPreview) {
      onExpand();
    }
  };

  return (
    <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
      {!isExpanded ? (
        <div className="relative h-full">
          {/* Compact Video Ad */}
          <div 
            className={`relative cursor-pointer transform transition-all duration-300 ${
              !isInPreview ? 'hover:scale-105' : ''
            } w-full h-full`}
            onClick={handleExpand}
            onMouseEnter={() => setShowControls(true)}
            onMouseLeave={() => setShowControls(false)}
          >
            {/* Video Container */}
            <div className="relative w-full h-full  overflow-hidden">
              <video
                ref={videoRef}
                className="w-full h-full object-cover"
                muted
                loop
                playsInline
                autoPlay
                // onPlay={() => setIsPlaying(true)}
                // onPause={() => setIsPlaying(false)}
              >
                <source src="/assets/Luxury.MP4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>

              {/* Play/Pause Overlay */}
              {/* <div 
                className={`absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center transition-opacity duration-300 ${
                  showControls || !isPlaying ? 'opacity-100' : 'opacity-0'
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  handlePlayPause();
                }}
              > */}
                {/* <div className="w-12 h-12 bg-white bg-opacity-80 rounded-full flex items-center justify-center hover:bg-opacity-100 transition-all duration-200">
                  {isPlaying ? (
                    <Pause size={24} className="text-gray-800" />
                  ) : (
                    <Play size={24} className="text-gray-800 ml-1" />
                  )}
                </div> */}
              {/* </div> */}

              {/* Ad Label */}
              <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
                AD
              </div>

              {/* Brand/CTA Overlay */}
              {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/50 to-transparent p-3">
                <div className="text-white">
                  <h4 className="font-bold text-sm mb-1">Premium Content</h4>
                  <p className="text-xs text-white/80 mb-2">Experience the difference</p>
                  <button className="bg-white text-black px-3 py-1 rounded-full text-xs font-medium hover:bg-gray-200 transition-colors">
                    Learn More
                  </button>
                </div>
              </div> */}
            </div>

            {/* Click to expand hint */}
            {/* {!isInPreview && showControls && (
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                <div className="bg-black/70 text-white px-3 py-1 rounded-full text-xs whitespace-nowrap">
                  Click to expand!
                </div>
              </div>
            )} */}
          </div>
        </div>
      ) : (
        /* Expanded Video Experience - Full Screen */
        <div className="w-full h-full flex items-center justify-center relative">
          {/* <button
            onClick={onClose}
            className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
          >
            ×
          </button> */}
          
          <div className="relative w-full h-full max-w-4xl">
            <video
              ref={videoRef}
              className="w-full h-full object-contain"
              controls
              autoPlay
              muted
              loop
              playsInline
            >
              <source src="/assets/Luxury.MP4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* Brand overlay for expanded view */}
            {/* <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm rounded-lg p-4 text-white">
              <h3 className="text-xl font-bold mb-2">Premium Experience</h3>
              <p className="text-sm opacity-80 mb-3">Discover what makes us different</p>
              <button className="bg-white text-black px-6 py-2 rounded-full font-medium hover:bg-gray-200 transition-colors">
                Get Started
              </button>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

function LuxaryCloseset() {
  const [isMobile, setIsMobile] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>

    <Helmet>
           <title>
    Luxury Closet Campaign | Hotspot Ad Showcase by Bidbox
            </title>
            <meta
              name="description"
              content="Discover how Luxury Closet engages audiences with Hotspot ads on Bidbox. Explore interactive campaigns that boost fashion visibility & brand appeal."
            />
            {/* <meta
              name="keywords"
              content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
            /> */}
             <link
              rel="canonical"
              href="https://bidbox.ai/hotspot/luxarycloset"
            />
            <meta
              name="robots"
              content="max-snippet:-1, max-image-preview:standard"
            />
            <meta name="robots" content="max-video-preview:-1" />
        </Helmet>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-4 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Back to Ad Gallery */}
              <div className="mb-6 lg:mb-8">
                {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                  <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform duration-200" />
                  <span className="text-sm font-medium">Back to Ad Gallery</span>
                </button> */}
              </div>

              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Tap the Closet. Discover the Luxe.
                  </h1>
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Hotspot
                  </span>
                </div>
                
                {/* View in preview site */}
                {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                  <Eye className="w-4 h-4" />
                  <span className="text-sm font-medium group-hover:underline">View in preview site</span>
                </button> */}
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                TURN EXPLORATION INTO ENGAGEMENT
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                This gamified ad turns a luxury closet into an interactive discovery zone. Users tap on hotspots to reveal product details—whether it's a statement bag, premium footwear, or designer wear. Each tap uncovers more, driving curiosity and product interaction. Just add your visuals and links to launch an immersive, shoppable brand experience
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
              <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                <div className="flex items-center space-x-4">
                  {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
                  <div className="flex items-center space-x-3">
                    <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                      Mobile
                    </span>
                    <button
                      onClick={() => setIsMobile(!isMobile)}
                      className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                      <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                    </button>
                    <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                      Desktop
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          publisher.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                      <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          

                        </div>
                        {/* Video Ad - Full width on mobile with same gap from top */}
                        <div className="mb-6">
                          <div className="h-96  rounded-lg overflow-hidden">
                            <VideoAdContent 
                              isInPreview={true}
                              isExpanded={isExpanded}
                              onExpand={() => setIsExpanded(true)}
                              onClose={() => setIsExpanded(false)}
                            />
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        {/* Additional content placeholders */}
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                         

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-2xl mx-auto">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-6">
                          <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 publisher.com
                          </div>
                        </div>
                        <div className="flex space-x-1">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Browser content area */}
                      <div className="p-1 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                        {/* Page header */}
                        <div className="mb-2">
                          <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
                          <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                        </div>

                        {/* Video Ad positioned in content with same gap from top */}
                        <div className="flex justify-center mb-2">
                          <div className="w-80 h-96   overflow-hidden">
                            <VideoAdContent 
                              isInPreview={true}
                              isExpanded={isExpanded}
                              onExpand={() => setIsExpanded(true)}
                              onClose={() => setIsExpanded(false)}
                            />
                          </div>
                        </div>

                        {/* Additional content placeholders */}
                        <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                        <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                        <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Expanded Video Overlay */}
      {isExpanded && (
        <div className="fixed inset-0 z-50">
          <VideoAdContent 
            isExpanded={true}
            onClose={() => setIsExpanded(false)}
          />
        </div>
      )}

      <style jsx>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .animate-slide-up {
          animation: slide-up 0.6s ease-out forwards;
        }
        
        .animate-fade-in {
          animation: fade-in 0.6s ease-out forwards;
        }
      `}</style>
    </div>

    <div className="max-w-7xl mx-auto px-4 py-10">
          <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
    
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {/* Card 1 */}
            <Link to="/quiz/ramadan" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/rama.webp"
                alt="Card 1"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Ramadan</h2>
              </div>
            </Link>
    
            {/* Card 2 */}
            <Link to="/dynamic-calculator/zakat" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/zakat.webp"
                alt="Card 2"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Zakat Calculator</h2>
              </div>
            </Link>
    
            {/* Card 3 */}
            <Link to="/interactive-selector/donation" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/donation.png "
                alt="Card 3"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Donation</h2>
              </div>
            </Link>
    
            {/* Card 4 */}
            <Link to="/spin-the-wheel/mamaearth" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/mam1.jpg"
                alt="Card 4"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Mama Earth</h2>
              </div>
            </Link>
    
           
          </div>
        </div>
    </>
  );
}

export default LuxaryCloseset;    
    

// import React, { useState,  useRef } from 'react';
// import { ChevronLeft, ChevronRight, Copy } from 'lucide-react';
// import { motion, AnimatePresence } from 'framer-motion';

// export default function LuxaryCloseset() {
//     const [selectedDevice, setSelectedDevice] = useState('Mobile');
//     const [isPlaying, setIsPlaying] = useState(false);
//     const videoRef = useRef(null);
  
//     const handleVideoClick = () => {
//       if (videoRef.current) {
//         videoRef.current.play();
//         setIsPlaying(true);
//       }
//     };
  
//     return (
//       <div className="flex flex-col md:flex-row min-h-screen bg-gradient-to-tr from-gray-100 to-gray-200 p-4 gap-4 mt-14 overflow-hidden">
//         {/* Left Sidebar */}
//         <motion.div
//           initial={{ x: -50, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           transition={{ duration: 0.6 }}
//           className="w-full md:w-64 bg-white rounded-2xl shadow-lg p-6 flex flex-col gap-6"
//         >
//           <div>
//             <h1 className="text-2xl font-bold text-gray-800 mb-1">Luxury Upsize</h1>
//             <p className="text-sm text-blue-500 mb-2">ID: 235756</p>
//             <button className="text-sm text-blue-500 hover:underline">Switch to previous version</button>
//           </div>
  
//           <motion.div
//             whileHover={{ scale: 1.02 }}
//             className="bg-gradient-to-r from-blue-500 to-purple-500 text-white p-4 rounded-xl shadow-md"
//           >
//             <h3 className="font-semibold mb-2 truncate">Luxury Upsize_Luxury_upsize...</h3>
//             <div className="text-xs space-y-1">
//               <p>Ad dimension: 300x600</p>
//               <p>Ad type: Banner tag</p>
//             </div>
//           </motion.div>
//         </motion.div>
  
//         {/* Center Content */}
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.6 }}
//           className="flex-1 flex flex-col gap-4"
//         >
//           {/* Header */}
//           <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
//             <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
//             Luxury Upsize_Luxury
//               <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600" />
//             </h2>
//             <div className="flex items-center gap-2">
//               {['Mobile', 'Desktop'].map((device) => (
//                 <button
//                   key={device}
//                   className={`px-3 py-1 rounded-full text-xs transition-all ${
//                     selectedDevice === device
//                       ? 'bg-purple-500 text-white'
//                       : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
//                   }`}
//                   onClick={() => setSelectedDevice(device)}
//                 >
//                   {device}
//                 </button>
//               ))}
//             </div>
//           </div>
  
//           {/* Navigation */}
//           <div className="bg-white rounded-2xl shadow-lg p-4 flex items-center justify-between">
//             <motion.button whileHover={{ scale: 1.05 }} className="flex items-center gap-2 text-gray-500 hover:text-gray-700">
//               <ChevronLeft className="h-4 w-4" />
//               Prev Ad
//             </motion.button>
//             <motion.button whileHover={{ scale: 1.05 }} className="flex items-center gap-2 text-gray-500 hover:text-gray-700">
//               Next Ad
//               <ChevronRight className="h-4 w-4" />
//             </motion.button>
//           </div>
  
//           {/* Ad Preview Area */}
//           <div className="flex-1 bg-white rounded-2xl shadow-lg p-4 md:p-8 flex items-center justify-center relative overflow-auto">
//             {/* Navigation Arrows */}
//             <motion.button
//               whileHover={{ scale: 1.1 }}
//               className="absolute left-4 top-1/2 transform -translate-y-1/2 flex items-center gap-1 text-gray-400 hover:text-gray-600 bg-white px-2 py-1 rounded-full shadow-md text-sm"
//             >
//               <ChevronLeft className="h-4 w-4" />
//               Prev Ad
//             </motion.button>
  
//             <motion.button
//               whileHover={{ scale: 1.1 }}
//               className="absolute right-4 top-1/2 transform -translate-y-1/2 flex items-center gap-1 text-gray-400 hover:text-gray-600 bg-white px-2 py-1 rounded-full shadow-md text-sm"
//             >
//               Next Ad
//               <ChevronRight className="h-4 w-4" />
//             </motion.button>
  
//             {/* Device Frame with Hover Animation */}
//             <AnimatePresence mode="wait">
//               {selectedDevice === 'Mobile' ? (
//                 <motion.div
//                   key="mobile"
//                   initial={{ opacity: 0, scale: 0.9 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   exit={{ opacity: 0, scale: 0.9 }}
//                   transition={{ duration: 0.4 }}
//                   className="relative max-w-xs mx-auto"
//                 >
//                   <div className="absolute -inset-2 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-50 rounded-3xl"></div>
  
//                   <div className="bg-gray-200 rounded-3xl p-3 shadow-lg">
//                     <div className="bg-white rounded-2xl p-2 shadow-inner">
//                       <div
//                         className="w-[250px] h-[500px] bg-black rounded-xl overflow-hidden relative group cursor-pointer"
//                         onClick={handleVideoClick}
//                       >
//                         <video ref={videoRef} src="/assets/Luxury.mp4" muted
//               playsInline
//               loop className="w-full h-full object-cover" />
//                         {/* Hover Overlay */}
//                         {!isPlaying && (
//                           <motion.div
//                             initial={{ opacity: 0 }}
//                             whileHover={{ opacity: 1 }}
//                             className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-lg font-semibold"
//                           >
//                             Click to Play
//                           </motion.div>
//                         )}
//                       </div>
//                     </div>
//                     <div className="w-24 h-1 bg-gray-400 rounded-full mx-auto mt-2"></div>
//                   </div>
//                 </motion.div>
//               ) : (
//                 <motion.div
//                   key="desktop"
//                   initial={{ opacity: 0, scale: 0.9 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   exit={{ opacity: 0, scale: 0.9 }}
//                   transition={{ duration: 0.4 }}
//                   className="relative max-w-xs mx-auto"
//                 >
//                   <div className="absolute -inset-2 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-50 rounded-xl"></div>
  
//                   <div className="bg-white rounded-xl shadow-lg p-4">
//                     <div
//                       className="w-[250px] h-[500px] bg-black rounded overflow-hidden relative group cursor-pointer"
//                       onClick={handleVideoClick}
//                     >
//                       <video ref={videoRef} src="/assets/Luxury.mp4"  muted
//               playsInline
//               loop className="w-full h-full object-cover" />
//                       {/* Hover Overlay */}
//                       {!isPlaying && (
//                         <motion.div
//                           initial={{ opacity: 0 }}
//                           whileHover={{ opacity: 1 }}
//                           className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-lg font-semibold"
//                         >
//                           Click to Play
//                         </motion.div>
//                       )}
//                     </div>
//                   </div>
//                 </motion.div>
//               )}
//             </AnimatePresence>
//           </div>
//         </motion.div>
  
//         {/* Right Sidebar */}
//         <motion.div
//           initial={{ x: 50, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           transition={{ duration: 0.6 }}
//           className="w-full md:w-80 bg-white rounded-2xl shadow-lg p-6 flex flex-col justify-between"
//         >
//           <div>
//             <h3 className="text-lg font-semibold text-gray-800 mb-6">Creative Details</h3>
  
//             <div className="space-y-4">
//               <div>
//                 <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Dimension:</h4>
//                 <p className="text-gray-800">300x600</p>
//               </div>
  
//               <div>
//                 <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Type:</h4>
//                 <p className="text-gray-800">Banner  tag</p>
//               </div>
  
//               <div>
//                 <h4 className="text-sm font-medium text-gray-600 mb-1">Creative ID:</h4>
//                 <p className="text-gray-800">1526050</p>
//               </div>
  
//               <button className="text-blue-500 hover:underline text-sm mt-4">
//                 Open Full-Size Creative
//               </button>
//             </div>
//           </div>
  
//           <div className="flex justify-center mt-6">
//             <div className="w-32 h-32 bg-gray-100 border-2 border-gray-300 p-2 flex items-center justify-center">
//               <span className="text-gray-500">QR Code</span>
//             </div>
//           </div>
//         </motion.div>
//       </div>
//     );
//   }